/*
Copyright 2017 - 2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with the License. A copy of the License is located at
    http://aws.amazon.com/apache2.0/
or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and limitations under the License.
*/

import React, { Component } from 'react';
//import { Row, Icon } from 'react-materialize';
//import AppRoute from '../index';
//import { Segment, Button, Divider, Input, Form, Label, Modal, Image } from 'semantic-ui-react';
import {Link, Redirect } from 'react-router-dom';
//import '../css/general.css';
//import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
//import awsmobile from '../aws-exports';
import {Auth} from 'aws-amplify';
//import {grey500, white} from '@material-ui/core/colors';
//import PersonAdd from '@material-ui/icons/PersonAdd';
//import Help from '@material-ui/icons/Help';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
//import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const logo = require('../components/images/hipkar-logo-text.png');

const styles = theme => ({
  container: {
    paddingTop: '10%',
    display: 'flex',
    width:'100%',
    height:'100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logoContainer: {
    display: 'flex',
    paddingTop: '2em',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: 400,
  },
  hipkarLogo: {
    maxWidth: '50%',
  },
  textFieldContainer: {
    display: 'flex',
    width: '400',
    height: 380,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textField: {
    marginLeft: theme.spacing.unit*3,
    marginRight: theme.spacing.unit*3,
    width: 346,
  },
  buttonsContainer: {
    display: 'flex',
    paddingTop: '2em',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: 400,
  },
  validationLabels: {
    marginLeft: theme.spacing.unit*3,
  },
});

class Login extends Component {
    state = {
        username: '',
        password: '',
        code: '',
        verificationCode: '',
        logInStatus: false,
        forgetPasswor: false,
        invalidUserNameMessage: '',
        invalidPasswordMessage: '',
        modalOpen: false,
        invalidCodeMessage: '',
        enterMFA: false,
        enableResend: false,
        cognitoUser: ''
    };

    handleChange = email => event => {
      this.setState({
        username: event.target.value,
        errorMsg: null,
      });
    };

    countDownResendVerificationCode = () => {

        let counter = 10;
        var seconds = setInterval(() => {
            if (counter === 0) {
                clearInterval(seconds);
                this.setState(() => {
                    return {
                        enableResend: true
                    }
                });
            }
            counter--;
        }, 1000);
    }

    signInCustomer = async (e) => {
        e.preventDefault();
        // this.setState(() => {
        //     this.username = this.state.username;
        //     this.password = this.state.password;
        // });
        //console.log('password: ' + this.state.password);
       Auth.signIn(this.state.username, this.state.password)
            .then(data => {
                //console.dir(data);
                // if (!this.state.enableResend) {
                //     this.setState(() => {
                //         enableResend: false
                //     });
                //     //this.countDownResendVerificationCode();
                // }
                this.setState(() => ({enterMFA: true, logInStatus: true, cognitoUser: data}));
                localStorage.setItem('isLoggedIn','true');
                localStorage.setItem('username',data.username);
                this.props.onAuthComplete();
            })
            .catch(err => {
              //console.log(err)
              this.setState({
                errorMsg: err.message,
              });
            });
    }

    sendVerificationCode = async(e) => {
        e.preventDefault();
        Auth.confirmSignIn(this.state.cognitoUser, this.state.code)
            .then(
                localStorage.setItem('isLoggedIn',true),
                this.setState(() => {
                    return {
                        logInStatus: true
                    }
                })
            )
            .catch (err => console.log(err));
    }

    render() {
        const { logInStatus, errorMsg } = this.state;
        const { classes } = this.props;
        return (
             <div className={classes.container}>
              { !logInStatus &&
                (

                  <Paper className={classes.textFieldContainer} elevation={0}>
                    <div className={classes.logoContainer}>
                      <img src={logo} className={classes.hipkarLogo}  alt="hipkar - get the best deal on a car lease" />
                    </div>
                  <div>
                    <TextField
                      id="email"
                      label="Email"
                      className={classes.textField}
                      value={this.state.username}
                      onChange={this.handleChange('email')}
                      margin="normal"
                    />
                    <TextField
                      id="password-input"
                      label="Password"
                      className={classes.textField}
                      type="password"
                      onChange = {(event) => this.setState({password:event.target.value, invalidCredentialsMessage: ''})}
                      autoComplete="current-password"
                      margin="normal"
                    />
                  </div>
                  { (errorMsg) &&
                  <Typography className={classes.validationLabels} variant="body1" color="error" gutterBottom>
                    {errorMsg}
                  </Typography>
                  }
                  <div className={classes.buttonsContainer}>
                    <Button variant="outlined" component={Link} to={'/'}  style={{marginRight: 1 + 'em'}}>Cancel</Button>
                    <Button variant="outlined" onClick={this.signInCustomer} color="primary" style={{marginRight: 2 + 'em'}}>Login</Button>
                  </div>
                  <div className={classes.buttonsContainer}>
                    <Link to="/forget" style={{marginRight: 1 + 'em'}}>
                      <Typography variant="body1" gutterBottom>
                        Forgot Password?
                      </Typography>
                    </Link>
                    <Link to="/register" style={{marginRight: 2 + 'em'}}>
                      <Typography variant="body1" gutterBottom>
                        Register
                      </Typography>
                    </Link>
                  </div>
                </Paper> ) }

                { logInStatus && (<Redirect to="/" />) }
            </div>


        );
    }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/Auth/Login.jsx